export const POSTER_SIZE = '342'; // 154 185 342
export const BACKDROP_SIZE = '780';
export const CAST_SIZE = '92';
export const CAST_NUMBER = 20;
export const VIDEO_NUMBER = 10;
export const BASE_URL = 'https://api.themoviedb.org/3';
export const API_KEY = 'e616cd78f7df65758287d12dbeae7d4a';
export const TIMEOUT_SEC = 10;
export const BASE_IMG_URL = 'https://image.tmdb.org/t/p/w';